// extracted by mini-css-extract-plugin
export default {"modalAgregarPagoContainer":"AgregarPagoComponent_modalAgregarPagoContainer__WzJpp"};